// copyTextWithToastr.js
'use strict';
import pushToastr from '../action/pushToastr.js';
import copyTextToClipboard from '../resource/copyTextToClipboard.js';
/**
 * Copy text to clipboard
 * @kind action
 * @param {string} {copiedText} - text which should be copied to clipboard
 * @param {string} {successfulText} - text for copy successfully.
 * @param {string} {failedText} - text for copy fail.
 * @param {string} {durationSec} - duration seconds of display.
 * @return {Promise} Action promise.
 */
const copyTextWithToastr =
  ({
    copiedText,
    successfulText,
    failedText,
    durationSec = 2,
    color = 'success',
  }) =>
  async dispatch => {
    try {
      await copyTextToClipboard(copiedText);
      dispatch(
        pushToastr({
          textKey: successfulText,
          durationSec,
          color,
        })
      );
    } catch (error) {
      dispatch(
        pushToastr({
          textKey: failedText,
          durationSec,
          color: 'error',
        })
      );
    }
  };

export default copyTextWithToastr;
